// extracted by mini-css-extract-plugin
export var chatHtmlText = "_oq-2";
export var chatLink = "_oq-0";
export var chatText = "_oq-1";